import _ from 'lodash';
import { takeLatest, call, put } from 'redux-saga/effects';
import { getSavedCardsRequest, getSavedCardsResponse } from '../../slices/customer';
import axios from '../axiosConfig';
import { setDefaultSelectedCard } from '../../slices/trip';

function* getSavedCardsWorker({ payload: { customerId, withAddressOnly, paymentMethodIndex } }) {
  try {
    const url = '/users/savedCards';
    const config = {
      method: 'post',
      url,
      data: JSON.stringify({
        customerId: customerId != null ? customerId : null,
        withAddressOnly: withAddressOnly || false,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);
    if (data && data.length) {
      yield put(
        setDefaultSelectedCard({
          customerId,
          cards: data,
        }),
      );
    }
    yield put(
      getSavedCardsResponse({
        error: !data || !data.length ? undefined : 'Could not find saved cards!',
        cards: data,
        customerId,
      }),
    );
  } catch (error) {
    yield put(getSavedCardsResponse({ error: 'Problem in sending request!', customerId }));
    console.error(error);
  }
}

function* getSavedCardsWatcher() {
  yield takeLatest(getSavedCardsRequest.toString(), getSavedCardsWorker);
}

export default getSavedCardsWatcher;
